import CommentThread from './CommentThread'

export default CommentThread
// eslint-disable-next-line import/export
export * from './CommentThread'
